import PosCaisseHeaderClock from './PosCaisseHeaderClock.jsx';
import PosImmersiveToggle from './PosImmersiveToggle.jsx';
import { resolvePosCommercantTimeZoneFromSources } from '../../utils/posCaisseClock.js';
import { POS_Z_CLASS } from '../../utils/posZLayers';

/**
 * Bandeau horloge partagé — chrome page (sous les modales POS, voir posZLayers).
 * Fuseau : prop explicite ou admin_user.commercant.timezone si présent ; sinon Europe/Paris (documenté).
 */
export default function PosCaisseSharedHeader({
  commercantTimeZone,
  commercant,
  className = '',
  variant = 'light',
}) {
  const { timeZone, source, fallbackUsed } = resolvePosCommercantTimeZoneFromSources({
    commercantTimeZone,
    commercant,
  });

  const shellClass =
    variant === 'dark'
      ? 'border-slate-700/80 bg-slate-950/95'
      : 'border-slate-200/80 bg-white/95';

  return (
    <div
      data-testid="pos-caisse-shared-header"
      data-pos-clock-source={source}
      data-pos-clock-fallback={fallbackUsed ? '1' : '0'}
      className={`sticky top-0 ${POS_Z_CLASS.pageHeader} flex items-center justify-end gap-2 border-b backdrop-blur px-3 sm:px-4 py-1.5 sm:py-2 ${shellClass} ${className}`}
    >
      <PosImmersiveToggle />
      <PosCaisseHeaderClock commercantTimeZone={timeZone} variant={variant} clockSource={source} />
    </div>
  );
}
